import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

/**
 * Preset de PrimeNG para SIPCO — identidad Grant Thornton.
 *
 * Antes se usaba el preset Aura tal cual (primario verde esmeralda) y luego se
 * repintaba a golpe de SCSS. Definir los tokens aquí hace que los componentes de
 * PrimeNG tomen la marca de raíz: botones, diálogos, paginador, dropdowns y
 * formularios quedan alineados sin overrides.
 *
 * Los valores de color provienen del CSS de producción de grantthornton.mx.
 * Los neutros son cálidos (R>G>B) a propósito: es lo que distingue la paleta GT
 * del slate frío por defecto.
 *
 * Debe mantenerse en paréntesis con `tailwind.config.js` (escala `surface` y
 * paletas primary/accent/warn) y con `src/styles/common/_variables.scss`.
 */
export const SipcoPreset = definePreset(Aura, {
    primitive: {
        borderRadius: {
            none: '0',
            xs  : '2px',
            sm  : '4px',
            md  : '6px',
            lg  : '8px',
            xl  : '12px'
        }
    },
    semantic: {
        // Rampa de marca: el morado GT #4f2d7f queda anclado en el stop 600.
        primary: {
            50 : '#faf7fd',
            100: '#efe8f7',
            200: '#ddcfee',
            300: '#c3aade',
            400: '#a06dff',
            500: '#7a4fae',
            600: '#4f2d7f',
            700: '#442870',
            800: '#38215c',
            900: '#2b144d',
            950: '#1c0d33'
        },
        borderRadius: {
            none: '0',
            xs  : '2px',
            sm  : '4px',
            md  : '6px',
            lg  : '8px',
            xl  : '12px'
        },
        colorScheme: {
            light: {
                primary: {
                    color        : '#4f2d7f', // 10.43:1 sobre blanco (AAA)
                    contrastColor: '#ffffff',
                    hoverColor   : '#442870',
                    activeColor  : '#38215c'
                },
                highlight: {
                    background     : '#e8e1ee',
                    focusBackground: '#ddd2e6',
                    color          : '#4f2d7f',
                    focusColor     : '#2b144d'
                },
                // Neutros cálidos GT — sustituyen al slate frío de Aura.
                surface: {
                    0  : '#ffffff',
                    50 : '#faf9f8',
                    100: '#f2f1ef',
                    200: '#e0dcd7',
                    300: '#d0cac3',
                    400: '#b3aaa1',
                    500: '#8a8178',
                    600: '#6b625a',
                    700: '#544c45',
                    800: '#3d3730',
                    900: '#282320',
                    950: '#191512'
                }
            }
        }
    }
});
